"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Calendar = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _pickers = require("@material-ui/pickers");

var _dateFns = _interopRequireDefault(require("@date-io/date-fns"));

var _Day = _interopRequireDefault(require("./Day"));

var _excluded = ["renderCustomDay", "dayButtonDataQa"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Calendar = function Calendar(_ref) {
  var props = (0, _extends2["default"])({}, _ref);

  var _useState = (0, _react.useState)(new Date()),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      selectedDate = _useState2[0],
      handleDateChange = _useState2[1];

  var renderCustomDay = props.renderCustomDay,
      dayButtonDataQa = props.dayButtonDataQa,
      newProps = (0, _objectWithoutProperties2["default"])(props, _excluded);
  return /*#__PURE__*/_react["default"].createElement("div", {
    "data-qa": newProps.dataQa
  }, /*#__PURE__*/_react["default"].createElement(_pickers.MuiPickersUtilsProvider, {
    utils: _dateFns["default"]
  }, /*#__PURE__*/_react["default"].createElement(_pickers.DatePicker, (0, _extends2["default"])({
    disableToolbar: true,
    PopoverProps: {
      'data-qa': props.dataQa
    },
    value: selectedDate,
    onChange: handleDateChange,
    renderDay: function renderDay(date, selectedDate, dayInCurrentMonth, DayComponent) {
      var renderCustomDayFunction = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : renderCustomDay;
      var dayButtonDataQaProp = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : dayButtonDataQa;
      return /*#__PURE__*/_react["default"].createElement(_Day["default"], {
        date: date,
        selectedDate: selectedDate,
        dayInCurrentMonth: dayInCurrentMonth,
        DayComponent: DayComponent,
        renderCustomDayFunction: renderCustomDayFunction,
        dayButtonDataQaProp: dayButtonDataQaProp
      });
    }
  }, newProps))));
};

exports.Calendar = Calendar;
Calendar.propTypes = {
  /** onChange callback called upon change of selected date */
  onChange: _propTypes["default"].func.isRequired,

  /** Calendar Value */
  value: _propTypes["default"].instanceOf(Date).isRequired,

  /**Calendar container type option  */
  variant: _propTypes["default"].string,

  /** Right arrow icon. */
  rightArrowIcon: _propTypes["default"].element,

  /** Left arrow icon. */
  leftArrowIcon: _propTypes["default"].element,

  /** Props to pass to right arrow button */
  rightArrowButtonProps: _propTypes["default"].object,

  /** Props to pass to left arrow button */
  leftArrowButtonProps: _propTypes["default"].object,

  /** DataQa attribute for each calendar day */
  dayButtonDataQaProp: _propTypes["default"].string,

  /** Custom renderer for specific days. */
  renderCustomDay: _propTypes["default"].func,

  /** Disable specific dates. */
  shouldDisableDate: _propTypes["default"].func
};
Calendar.defaultProps = {
  dataQa: 'calendar-container',
  variant: 'static',
  leftArrowButtonProps: {
    'data-qa': 'calendar-arrow-left'
  },
  rightArrowButtonProps: {
    'data-qa': 'calendar-arrow-right'
  }
};
var _default = Calendar;
exports["default"] = _default;